<template>
  <div class="second-step">
      <HeaderFormLoginSecondStep  :authType="authType" />

      <FormLoginSecondStepSMS 
        @change-auth-type="changeAuthType" 
        @save-auth-tokens="login"
        @clear-logged-user="cancelar"
        class="animate__fadeInUp" 
        v-if="authTypeSMS"/>

      <FormLoginSecondStepMicrosoftAuthenticator 
        @change-auth-type="changeAuthType" 
        @save-auth-tokens="login"
        @clear-logged-user="cancelar"
        class="animate__fadeInUp" 
        v-else />
  </div>
</template>

<script>

import FormLoginSecondStepSMS from "./FormLoginSecondStepSMS.vue"
import FormLoginSecondStepMicrosoftAuthenticator from "./FormLoginSecondStepMicrosoftAuthenticator.vue"
import HeaderFormLoginSecondStep from "./HeaderFormLoginSecondStep.vue"
import { SMS, TOTP } from "@/util/utils"
import LoginUtils from '@/util/LoginUtils'
import { mapActions, mapGetters } from "vuex"
export default {
  name: "FormLoginSecondStep",
  components: {
    FormLoginSecondStepSMS,
    FormLoginSecondStepMicrosoftAuthenticator,
    HeaderFormLoginSecondStep
  },
  data() {
    return {
      authType: TOTP
    }
  },
  computed: {
    ...mapGetters("user", ["jwt"]),
    authTypeSMS () {
      return this.authType === SMS;
    }
  },
  methods: {
    ...mapActions("user", ["saveOuthTokens", "clearLoggedUser"]),
    ...mapActions("app", ["redirectAfterLogin"]),
    changeAuthType (value) {
      this.authType = value === SMS ? TOTP : SMS
    },
    login(response) {
      this.saveOuthTokens({accessToken: response.access_token, refreshToken: response.refresh_token, changedUser: true})
      .then(() => {
        LoginUtils.saveDevice(this.jwt.user_name, response)
        LoginUtils.saveLastAuthTypeUsed(this.authType)
        this.redirectAfterLogin()
      }) 
    },
    cancelar() {      
      this.clearLoggedUser()
    },
  },
  mounted() {
    this.authType = LoginUtils.getLastAuthTypeUsed();
  }
}
</script>

<style>
.btn-auth-type{
   margin: 0px;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: 0.00938em;
    font-size: 14px;
    font-family: optum-sans-bold;
    color: rgb(0, 38, 119);
    cursor: pointer;
}

.second-step {
  margin: 0;
  text-align: left !important;
}
</style>